"use strict";

export function toggleCollapseFilterGroup() {
    $(this).parent().toggleClass('open');
}

export function getFormData() {
    const form = $(this).is("form") ? $(this) : $('form.filters');
    return form.serializeArray().reduce((acc, field) => {
        if (!acc[field.name]) {
            acc[field.name] = [];
        }
        acc[field.name].push(field.value);
        return acc;
    }, {});
}

export function updateFiltersLabels() {
    const form = $(this).is("form") ? $(this) : $('form.filters');
    const formData = getFormData.call(form);

    form.find('.filter__header').removeClass('filter__header--selected');
    form.find('.filter__selected-items').html('');
    Object.entries(formData).forEach(([field, values]) => {
        const formGroup = form.find(`:input[name="${field}"]`).closest('.filter__group');
        const formGroupName = formGroup.attr('data-filter-group');
        if (formGroup.attr('data-filter-type') === 'range') {
            formGroup.find('.filter__header').addClass('filter__header--selected');
            // console.log('added filter__header--selected to', formGroup.find('.filter__header') );
            const minValue = formData[formGroupName + 'min'].join(', ');
            const maxValue = formData[formGroupName + 'max'].join(', ');
            const minRange = form.find(`:input[name="${formGroupName}min"]`).siblings('[data-range-slider]').attr('data-range-slider-min');
            const maxRange = form.find(`:input[name="${formGroupName}max"]`).siblings('[data-range-slider]').attr('data-range-slider-max');
            if ((!minValue && !maxValue) || (minValue === minRange && maxValue === maxRange)) {
                formGroup.find('.filter__selected-items').html('');
                formGroup.find('.filter__header').removeClass('filter__header--selected');
            } else {
                const units = formGroup.find('[data-range-slider]').attr('data-range-slider-units');
                formGroup.find('.filter__selected-items').html(`${minValue} - ${maxValue} ${units}`);
            }
        } else {
            formGroup.find('.filter__header').addClass('filter__header--selected');
            const labeledValues = values
                .filter((value) => !!value)
                .map((value) => {
                    if (formGroup.attr('data-filter-type') === 'checkbox') {
                        if (formGroup.find(`:input[value=${value}]`).closest('ul').closest('li').children('input[type="checkbox"]').prop("checked")) {
                            return null;
                        }
                    }
                    return formGroup.find(`:input[value=${value}] + label`).text();
                })
                .filter((value) => !!value);
            formGroup.find('.filter__selected-items').html(labeledValues.join(', '));
        }
    });
    $('.filter__group[data-filter-type="tree"]').each(function(index, element){
        const selectedItemsInGroup = $(element).find('.selected').map(function(){return $(this).text()}).get().join(', ');
        $(this).find('.filter__selected-items').html(selectedItemsInGroup);
    });
    // console.log('Filter labels were updated', formData);
}

export function onFiltersChange(event) {
    const form = $(this).is("form") ? $(this) : $('form.filters');
    const formData = getFormData.call(form);
    // console.log('Filters changed:', formData);
    updateFiltersLabels(form);

    if (event) {
        if (window.matchMedia("(min-width: 768px)").matches) {
            form.trigger('submit');
        } else {
            filtersGetItemsCount(form);
        }
    }
}

export function onFiltersReset(event) {
    const form = $(this).is("form") ? $(this) : $('form.filters');

    form.find('[data-range-slider]').each((index, slider) => {
        const min = slider.getAttribute('data-range-slider-min');
        const max = slider.getAttribute('data-range-slider-max');
        slider.noUiSlider.set([min, max]);
    });
    form.find('.filter__selected-items').html('');
    form.find(':input')
        .not('#searchstring')
        .val('')
        .removeAttr('selected')
        .removeAttr('checked');
    $('.selected-filters__container').remove();
    setTimeout(() => {
        onFiltersChange.call(this, event);
        form.trigger('submit');
    });
}

export function onFiltersOpen(event) {
    $('form.filters').addClass('open');
    $('body').addClass('filters-opened-on-mobile');
}

export function onFiltersClose(event) {
    $('form.filters').removeClass('open');
    $('body').removeClass('filters-opened-on-mobile');
}

export function onFilterRemoveOneUsingForm(event) {
    const parent = $(this).parent();
    const filterType = parent.attr('data-filter-type');
    const filterName = parent.attr('data-filter-filter');
    const filterValue = parent.attr('data-filter-value');
    if (filterType === 'range') {
        const form = $(`form.filters`);
        const slider = form.find(`[data-range-slider="${filterName}"]`)[0];
        if (slider) {
            const min = slider.getAttribute('data-range-slider-min');
            const max = slider.getAttribute('data-range-slider-max');
            slider.noUiSlider.set([min, max]);
            $(slider).parent().find('.range-slider__apply-range').trigger('click');
        }
    } else {
        const input = $(`form.filters :input[name="${filterName}"][value="${filterValue}"]`);
        input.prop('checked', false);
    }
    parent.remove();
    if (!$('.selected-filters__container .selected-filters__filter').length) {
        $('.selected-filters__container').remove();
    }
    onFiltersChange(event);
}

export function onFilterRemoveAllUsingUrl(event) {
    window.location = `${window.location.origin}${window.location.pathname.replace(/(page\/\d*)/, '')}`;
}

export function onFilterRemoveOneUsingUrl(event) {
    const parent = $(this).parent();
    const filterType = parent.attr('data-filter-type');
    const filterName = parent.attr('data-filter-filter');
    const filterValue = parent.attr('data-filter-value');
    let params = new URLSearchParams(window.location.search.slice(1));
    if (filterType === 'range') {
        params.delete(filterName + 'min');
        params.delete(filterName + 'max');
    } else {
        if (filterName.includes('[]')) {
            const values = params.getAll(filterName);
            values.splice(values.indexOf(filterValue), 1);
            params.delete(filterName);
            values.forEach(param => {
                params.append(filterName, param);
            });
        } else {
            params.delete(filterName);
        }
    }
    window.location = `${window.location.origin}${window.location.pathname.replace(/(page\/\d*)/, '')}?${params.toString()}`;
}

export function onFiltersSubmit(event) {
    event.preventDefault();
    const serialized = serializedFilterValue($(this));
    // console.log('Submit filters form:', serialized);
    const baseUrl = $('form.filters').attr('data-base-url');
    const path = baseUrl ? baseUrl : `${window.location.pathname}`;
    window.location = `${path}?${serialized}`;
}

export function serializedFilterValue(form) {
    const serialized = $('form.filters :input')
        .add('.catalog-toolbar select.sorting')
        .filter(function (index, element) {
            return $(element).val() !== '';
        })
        .serialize();
    return serialized;
}

export function filtersGetItemsCount(form) {
    const serialized = serializedFilterValue(form);
    // console.log('Get filtered items count for:', serialized);

    $.ajax({
        type: 'POST',
        url: '/filters/getCountItems',
        data: serialized,
        dataType: "json",
        success: function (res) {
            const count = +(res?.itemsCount) || 0;
            let countText = '';
            if (count > 1) {
                countText = `Afișează ${count} modele`;
            } else if (count === 1) {
                countText = `Afișează un model`;
            } else {
                countText = `Nu sunt rezultate de afișat`;
            }
            $('form.filters .filter__apply-button').text(countText).prop('disabled', isNaN(count) || count === 0);
            // const filters = res?.filterArray?.length || 0;
            // const filtersOpener = $('.catalog-toolbar .filters-opener');
            // $('.catalog-toolbar .filtered-items-count').text(`${count} ${count === 0 ? 'obiect' : 'obiecte'}`);
            // filtersOpener.find('.filters-opener__counter').text(filters);
            // if (filters) {
            //     filtersOpener.addClass('filters-opener--has-filters-applied');
            // } else {
            //     filtersOpener.removeClass('filters-opener--has-filters-applied');
            // }
        },
        error: function () {
            const countText = `Nu sunt rezultate de afișat`;
            $('form.filters .filter__apply-button').text(countText).prop('disabled', true);
            // $('.catalog-toolbar .filtered-items-count, .catalog-toolbar .filters-opener__counter').text('---');
            // $('.catalog-toolbar .filters-opener').removeClass('filters-opener--has-filters-applied');
        }
    });
}

export default function init() {
    if (!$('form.filters').length) {
        return;
    }

    updateFiltersLabels();

    jQuery('form.filters .filter__group .filter__header').on('click', toggleCollapseFilterGroup);
    jQuery('form.filters :input').on('change', onFiltersChange);
    jQuery('form.filters')
        .on('reset', onFiltersReset)
        .on('submit', onFiltersSubmit);

    jQuery('form.filters .filters__close-filters').on('click', onFiltersClose);

    jQuery('.catalog-toolbar .filters-opener').on('click', onFiltersOpen);

    jQuery('.catalog-toolbar select.sorting').on('change', onFiltersSubmit);

    jQuery('.selected-filters__clear-filters-button').on('click', onFilterRemoveAllUsingUrl);
    jQuery('.selected-filters__remove-filter').on('click', onFilterRemoveOneUsingUrl);
}
